import { render } from "./newUserModal.vue?vue&type=template&id=12e6947c&scoped=true"
import script from "./newUserModal.vue?vue&type=script&lang=js"
export * from "./newUserModal.vue?vue&type=script&lang=js"

import "./newUserModal.vue?vue&type=style&index=0&id=12e6947c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e6947c"]])

export default __exports__